module.exports = __webpack_public_path__ + "img/server-maintaince.c70d9352.png";